import Vue from 'vue'
import Vuex from 'vuex'
import persistanteState from 'vuex-persistedstate'
/*import * as Cookies from 'js-cookie'*/

// Import Portefeuille modules
import vehicles from './portefeuille/vehicles.module'
import housings from './portefeuille/housings.module'
import beneficiaries from './portefeuille/beneficiaries.module'
import documents from './portefeuille/documents.module'

Vue.use(Vuex);
export default new Vuex.Store({
    strict: true,
    plugins: [persistanteState()],
    modules: {
        vehicles,
        housings,
        beneficiaries,
        documents
    },
    state: {
        DevisReopen: {},
        activeStepper: 0,
        devisVoyageContainer: {},
        code_partenaire:null,
        token: null,
        user: {},
        user_quote_count:null,
        user_contract_count:null,
        devis: {},
        isUserLoggedIn: false,
        orderid: {},
        modePaiement: {},
        roles: null,
        rtek8dsr : null,//apikey
        bj7Dc3s : null, //paraphrase
        country : null
    },
    getters: {
        username: state => {
            if (state.token && state.user) {
                return state.user.prenom + ' ' + state.user.nom
            }
        }
    },
    mutations: {
        setDevisReopen(state, devis) {
            state.DevisReopen = devis
        },
        incrementStepper(state) {
            state.activeStepper++
        },

        decrementStepper(state) {
            state.activeStepper--
        },

        resetStepper(state) {
            state.activeStepper = 0
        },

        mutateContainerDevisVoyage(state, container) {
            state.devisVoyageContainer = {...state.devisVoyageContainer, ...container}
        },
        
        resetContainerDevisVoyage(state) {
            state.devisVoyageContainer = {}
        },
        
        selectCountry(state, data){
            if(data!=null){
                state.rtek8dsr =   window.btoa(data.apikey),// data.rtek8dsr,
                state.bj7Dc3s =  window.btoa(data.paraphrase), //data.bj7Dc3s
                state.country = data.country
            }
        },

        setToken(state, user) 
        {
            if (user !== null) {
                if (user.token) {
                    state.isUserLoggedIn    = true
                    state.token             = user.token
                    state.user              = user
                    state.code_partenaire   = user.code_partenaire
                    state.rtek8dsr          = window.btoa(user.apikey)
                    state.bj7Dc3s           = window.btoa(user.paraphrase)
                    state.country           = user.country
                }
            } else {
                state.isUserLoggedIn = false
                state.token = null
                state.user = null
                state.code_partenaire = null
                state.rtek8dsr ="",
                state.bj7Dc3s = ""
                state.country = null
            }

        },

        setUser(state, user) {
           if(user!=null){
                state.user = user
                state.code_partenaire = user.code_partenaire
           }else{
            state.user = null
            state.code_partenaire = null
           }
        },

        setRoles(state, roles) {
            state.roles = roles.AllRoles
            const superAdmin = state.roles.find((role) => role.name === "SuperAdmin");
                if (superAdmin) {
                    state.roles.splice(state.roles.indexOf(superAdmin), 1);

                }
        },

        setDevis(state, data) {
            state.devis = data
        },

        setDevisPayement(state, devis) {
            state.devispayement = devis
        },

        setuser_quote_count(state, user_quote_count){
            state.user_quote_count = user_quote_count
        },

        setuser_contract_count(state, user_contract_count){
            state.user_contract_count = user_contract_count
        },
        
        setDevisPayementDiffere(state, devisDiff) {
            state.devispayementDiffere = devisDiff
        },

        setNewcontrat(state, contrat) {
            state.Newcontrat = contrat
        },

        setNest(state, nest) {
            state.Newnest = nest
        },
        // ORDERID FOR UPAY
        setOrderId(state, orderid) {
            state.orderid = orderid
        },
        setmodePaiement(state, mode) {
            state.modePaiement = mode
        },
        setListeBeneficiaire(state, voyageurs) {
            state.listeBeneficiaire = voyageurs
        },
        setClient(state, client) {
            state.Client = client
        },
    },
    actions: {
        setDevisReopen({commit}, DevisReopen) {
            commit('setDevisReopen', DevisReopen)
        },
        incrementStepperAction({commit}) {
            return new Promise((resolve, reject) => {
                commit('incrementStepper')
            })
        },

        resetStepperAction({commit, state, dispatch}) {
            dispatch('incrementStepperAction')
                .then(() => {
                    if(state.activeStepper >= 3) {
                        commit('resetStepper')
                        commit("resetContainerDevisVoyage")
                    }
                })
        },

        selectCountry({commit}, data){
            commit('selectCountry', data)
        },

        setuser_quote_count({commit}, user_quote_count){
            commit('setuser_quote_count', user_quote_count)
        },
        
        setuser_contract_count({commit}, user_contract_count){
            commit('setuser_contract_count', user_contract_count)
        },

        setToken({commit}, token) {
            commit('setToken', token)
        },
        setUser({commit}, user) {
            commit('setUser', user)
        },
        setDevis({commit}, devis) {
            commit('setDevis', devis)
        },
        setRoles({ commit }, roles) {
            commit('setRoles', roles)
        },
        setDevisPayement({commit}, devispayement) {
            commit('setDevisPayement', devispayement)
        },
        setDevisPayementDiffere({commit}, devispayementDiffere) {
            commit('setDevisPayementDiffere', devispayementDiffere)
        },
        setNewcontrat({commit}, Newcontrat) {
            commit('setNewcontrat', Newcontrat)
        },
        setNest({commit}, nest) {
            commit('setNest', nest)
        },
        setClient({commit}, Client) {
            commit('setClient', Client)
        },
        // ORDERID FOR UPAY
        setOrderId({commit}, orderid) {
            commit('setOrderId', orderid)
        },
        setmodePaiement({commit}, mode) {
            commit('setmodePaiement', mode)
        },
        setListeBeneficiaire({commit}, voyageurs) {
            commit('setListeBeneficiaire', voyageurs)
        }
    }
})
